// extracted by mini-css-extract-plugin
module.exports = {"attributeBox":"attribute_attributeBox__2EGXF","attrLink":"attribute_attrLink__35hcb","attrImg":"attribute_attrImg__3-uP0","title":"attribute_title__27vuT"};